import {
  SURVEY_INTERSTITIAL_ROUTES,
  SURVEY_QUESTIONNAIRE_ROUTES,
  SurveyInterstitialRoute,
  SurveyQuestionnaireRoute,
} from '../surveyRoutes';

export const isValidInterstitialRoute = (value: string): value is SurveyInterstitialRoute => {
  return SURVEY_INTERSTITIAL_ROUTES.includes(value as SurveyInterstitialRoute);
};

export const isValidQuestionnaireRoute = (value: string): value is SurveyQuestionnaireRoute => {
  return SURVEY_QUESTIONNAIRE_ROUTES.includes(value as SurveyQuestionnaireRoute);
};

export const validateInterstitialRoute = (
  value: string | undefined,
): SurveyInterstitialRoute | null => {
  if (value === undefined || !isValidInterstitialRoute(value)) {
    return null;
  }
  return value;
};

export const validateQuestionnaireRoute = (
  value: string | undefined,
): SurveyQuestionnaireRoute | null => {
  if (value === undefined || !isValidQuestionnaireRoute(value)) {
    return null;
  }
  return value;
};
